import React from "react";
import { createBrowserRouter, createSearchParams, RouteObject } from "react-router-dom";
import WelfareHome from "../views/welfare/home/index";
import WelfareDetails from "../views/welfare/details/index";
import IntegralRule from "../views/integralRule";
import Question from "../views/question";
import PrivacyPolicy from "../views/privacyPolicy";
import UserAgreement from "../views/userAgreement";
import UserAgreementLife from "../views/userAgreement/life";
import WelfareList from "../views/welfare/list/index";
import GameHome from "../views/answerGame/home/index";
import GameQuestion from "../views/answerGame/question/index";
import GameRankinglist from "../views/answerGame/rankinglist/index";
import GamePublicity from "../views/answerGame/publicity/index";
import GameResult from "../views/answerGame/result/index";
import GameExceedTime from "../views/answerGame/exceedTime/index";
import BikeRide from "../views/bike_ride/index";
import BikeRideResult from "../views/bike_ride/result";
import CityCarbonHome from "../views/urbanCarbonSecrets/home/index";
import CityCarbonResult from "../views/urbanCarbonSecrets/rank/index";
import DownloadApp from "../views/downloadApp/index";
import WalletDescription from "~src/views/walletDescription";
import SdkList from "../views/privacyPolicy/sdkList";
import CommunityNorms from "../views/communityNorms";

import ShuiShenXingGuide from "../views/activity/shuishenxing/guide";
import ShuiShenXingAuth from "../views/activity/shuishenxing/auth";
import BillHome from "../views/bill/home";
import BillHistory from "../views/bill/history";
import BillDetails from "../views/bill/details";
import BillRelated from "../views/bill/related";
import BillRule from "../views/bill/rule";
import BillPrevie from "../views/bill/preview";
import CouponDetail from "~src/views/coupons/details";
import BlockChain from "~src/views/welfare/blockchain";
import Participant from '~src/views/welfare/participant';

const storage: string[] = ["token", "id", "avatarUrl", "nickname", "phoneNumber", "guid"]
const localStorageSetItem = async (list: string[]) => {
  const data = createSearchParams(window.location.search.split("?")[1] || "")
  list.forEach(async item => {
    if (data.get(item) && (!localStorage.getItem(`mio-${item}`) || localStorage.getItem(`mio-${item}`) !== data.get(item))) {
      await localStorage.setItem(`mio-${item}`, data.get(item) || "")
    }
  })
}



const OutputRoute = (router: RouteObject[]): RouteObject[] => {
  return router.map(item => ({
    ...item,
    loader: async ({ params, request }) => {
      localStorageSetItem(storage)
      return item.loader ? item.loader : undefined
    },
    children: item.children ? OutputRoute(item.children) : undefined
  })
  )
}


const router = createBrowserRouter(OutputRoute([
  {
    path: "welfare",
    children: [
      {
        path: "home",
        element: <WelfareHome />
      },
      {
        path: "details/:id",
        element: <WelfareDetails />
      },
      {
        path: "list",
        element: <WelfareList />
      },
      {
        path: "blockchain",
        element: <BlockChain />
      },
      {
        path: "records",
        element: <Participant />
      }
    ]
  },
  {
    path: "answer",
    children: [
      {
        path: "home",
        element: <GameHome />
      },
      {
        path: "question",
        element: <GameQuestion />
      },
      {
        path: "rankinglist",
        element: <GameRankinglist />
      },
      {
        path: "publicity",
        element: <GamePublicity />
      },
      {
        path: "result",
        element: <GameResult />
      },
      {
        path: "exceed",
        element: <GameExceedTime />
      },
    ]
  },
  {
    path: "integralRule",
    element: <IntegralRule />,
  },
  {
    path: "question",
    element: <Question />,
  },
  {
    path: "privacy_policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "user_agreement",
    element: <UserAgreement />,
  },
  {
    path: "privacy_policy/life",
    element: <PrivacyPolicy type="life" />,
  },
  {
    path: "user_agreement/life",
    element: <UserAgreementLife />,
  },
  {
    path: "bill",
    children: [
      {
        path: "home",
        element: <BillHome />
      },
      {
        path: "history",
        element: <BillHistory />
      },
      {
        path: "details",
        element: <BillDetails />
      },
      {
        path: "related",
        element: <BillRelated />
      },
      {
        path: "rule",
        element: <BillRule />
      },
      {
        path: "previe",
        element: <BillPrevie />
      },
    ]
  },
  // {
  //   path: "bill_share",
  //   element: <BillShare />,
  //   loader: async ({ params, request }) => {
  //     return (await (await getReport()).last_page)
  //   }
  // },
  // {
  //   path: "/fashion",
  //   children: [
  //     {
  //       path: "home",
  //       element: <Home />,
  //     },
  //     {
  //       path: "result",
  //       element: <FashionResult />
  //     }
  //   ]
  // }
  {
    path: "urban_carbon_secrets",
    children: [
      {
        path: "home",
        element: <CityCarbonHome />
      },
      {
        path: "rank",
        element: <CityCarbonResult />
      }
    ]
  },
  {
    path: "bike_ride",
    element: <BikeRide />,
  },
  {
    path: "bike_ride/result",
    element: <BikeRideResult />
  },
  // 因为当前下载链接不可改变，已对外投放
  {
    path: "download_app",
    element: <DownloadApp />
  },
  {
    path: "wallet_description",
    element: <WalletDescription />
  },
  {
    path: "privacy_policy/sdk_list",
    element: <SdkList />
  },
  {
    path: "community_norms",
    element: <CommunityNorms />
  },
  {
    path: "shuishenxing/guide",
    element: <ShuiShenXingGuide />
  },
  {
    path: "shuishenxing/auth",
    element: <ShuiShenXingAuth />
  },
  {
    path: "coupon",
    children: [
      {
        path: "details",
        element: <CouponDetail />
      }
    ]
  },
]))

export default router
